(function () {
  'use strict';

  var GIFT_WRAP_VARIANT_ID = '45818728153190'; // ← ラッピング商品バリアントID
  var GIFT_WRAP_PRICE = 330;

  var modeRadios     = document.querySelectorAll('input[name="gift_wrap_mode"]');
  var individualArea = document.getElementById('gift-wrap-individual');
  var totalArea      = document.getElementById('gift-wrap-total');
  var totalPriceEl   = document.getElementById('gift-wrap-total-price');
  var applyBtn       = document.getElementById('gift-wrap-apply-btn');
  var messageEl      = document.getElementById('gift-wrap-message');

  if (!applyBtn) return;

  var currentMode = 'none';

  // ---------- モード切替 ----------
  modeRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      currentMode = this.value;
      individualArea.style.display = currentMode === 'individual' ? 'block' : 'none';
      applyBtn.style.display       = currentMode !== 'none'       ? 'block' : 'none';
      hideMessage();

      if (currentMode === 'all') {
        showTotal(GIFT_WRAP_PRICE);
        totalArea.style.display = 'block';
      } else if (currentMode === 'none') {
        totalArea.style.display = 'none';
      } else {
        updateIndividualTotal();
      }
    });
  });

  // ---------- 個別：数量スピナー ----------
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('gift-wrap-qty-minus')) {
      var input = e.target.nextElementSibling;
      var val = parseInt(input.value, 10);
      if (val > 0) {
        input.value = val - 1;
        updateRowPrice(input);
        updateIndividualTotal();
      }
    }
    if (e.target.classList.contains('gift-wrap-qty-plus')) {
      var input = e.target.previousElementSibling;
      var max = parseInt(e.target.dataset.max, 10);
      var val = parseInt(input.value, 10);
      if (val < max) {
        input.value = val + 1;
        updateRowPrice(input);
        updateIndividualTotal();
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('gift-wrap-qty-input')) {
      var max = parseInt(e.target.dataset.max, 10);
      var val = parseInt(e.target.value, 10) || 0;
      if (val < 0) e.target.value = 0;
      if (val > max) e.target.value = max;
      updateRowPrice(e.target);
      updateIndividualTotal();
    }
  });

  function updateRowPrice(input) {
    var val = parseInt(input.value, 10) || 0;
    var priceEl = input.closest('.gift-wrap-item-controls').querySelector('.gift-wrap-item-price-dynamic');
    priceEl.textContent = '¥' + (val * GIFT_WRAP_PRICE).toLocaleString('ja-JP');
  }

  // ---------- 合計計算 ----------
  function updateIndividualTotal() {
    var total = 0;
    document.querySelectorAll('.gift-wrap-qty-input').forEach(function (input) {
      total += (parseInt(input.value, 10) || 0) * GIFT_WRAP_PRICE;
    });
    if (total > 0) {
      showTotal(total);
    } else {
      totalArea.style.display = 'none';
    }
  }

  function showTotal(amount) {
    totalArea.style.display = 'block';
    totalPriceEl.textContent = '¥' + amount.toLocaleString('ja-JP');
  }

  // ---------- 対象商品名を収集 ----------
  function getTargetItemNames() {
    if (currentMode === 'all') {
      return 'カートまとめてラッピング';
    }

    var names = [];
    document.querySelectorAll('.gift-wrap-qty-input').forEach(function (input) {
      var qty = parseInt(input.value, 10) || 0;
      if (qty > 0) {
        var nameEl = input.closest('.gift-wrap-item-row').querySelector('.gift-wrap-item-name');
        if (nameEl) {
          // × N個 を除去して商品名のみ取得
          var rawName = nameEl.textContent.replace(/×\s*\d+個/g, '').trim();
          names.push(rawName + '（' + qty + '個）');
        }
      }
    });
    return names.join('、');
  }


  // ---------- カートに追加 ----------
  applyBtn.addEventListener('click', function () {
  var quantity = 0;

  if (currentMode === 'all') {
    quantity = 1; // まとめてラッピングは必ず1
  } else if (currentMode === 'individual') {
    document.querySelectorAll('.gift-wrap-qty-input').forEach(function (input) {
      quantity += parseInt(input.value, 10) || 0;
    });
  }

  if (quantity === 0) {
    showMessage('ラッピング個数を1以上に設定してください。', 'error');
    return;
  }

  var targetNames = getTargetItemNames();
  var wrapType = currentMode === 'all' ? 'まとめてラッピング' : '個別ラッピング';

  setButtonLoading(true);
  hideMessage();

  // ① まずカート全体を取得
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      // ② ラッピング商品をすべて0に設定
      var updates = {};
      cart.items.forEach(function (item) {
        if (item.properties && item.properties['_gift_wrap'] === 'true') {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        return Promise.resolve();
      }

      // ③ 削除実行
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); });
    })
    .then(function () {
      // ④ 削除完了後に新しいラッピングを追加
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: GIFT_WRAP_VARIANT_ID,
          quantity: quantity,
          properties: {
            _gift_wrap: 'true',
            ラッピング方法: wrapType,
            対象商品: targetNames
          }
        })
      });
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart/add.js failed: ' + r.status);
      return r.json();
    })
    .then(function () {
      showMessage('ラッピングをカートに追加しました！', 'success');
      setTimeout(function () { window.location.reload(); }, 800);
    })
    .catch(function (err) {
      console.error(err);
      showMessage('エラーが発生しました。再度お試しください。', 'error');
      setButtonLoading(false);
    });
});

  // ---------- ユーティリティ ----------
  function showMessage(text, type) {
    messageEl.textContent = text;
    messageEl.className = 'gift-wrap-message ' + type;
    messageEl.style.display = 'block';
  }

  function hideMessage() {
    messageEl.style.display = 'none';
  }

  function setButtonLoading(loading) {
    applyBtn.disabled = loading;
    applyBtn.textContent = loading ? '処理中...' : 'ラッピングをカートに追加する';
  }

  

})();
